import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message } from "antd";
import { DeleteFilled, DownloadOutlined } from "@ant-design/icons";
import { get, del } from "../../../services";

const Admintable = () => {
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const limit = 10;

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/careers/application?page=${currentPage}&limit=${limit}&status=Active`)
      .then((response) => {
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/careers/application/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.properties?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, properties: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  // Table Columns
  const columns = [
    {
      title: "Sr",
      dataIndex: "",
      key: "sr",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      key: "phoneNumber",
      dataIndex: "phoneNumber",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <DownloadOutlined
              className="cursor-pointer delete-icon-admin"
              onClick={() => {
                window.open(data?.resume, "_blank");
              }}
            />
          </div>
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer delete-icon-admin" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="header4">
        <h3>Carrers</h3>
      </div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={adminData?.properties}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={adminData?.totalPages}
        onChange={(e) => {
          setCurrentPage(e);
          getAllAdmins(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Admintable;
